import React, { PureComponent,  } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Modal from 'components/Shared/Modals';
import Button from 'components/Shared/Common/Button';

const formatMessages = intl => ({ name }) => ({
    modalTitle: intl.formatMessage({
        id: 'modal.leaveFeed.title',
        defaultMessage: 'Quitter le groupe'
    }),
    modalContent: intl.formatMessage({
        id: 'modal.leaveFeed.content',
        defaultMessage: 'Voulez vous quitter le group "{name}" ?'
    }, {
        name
    }),
    buttonCancel: intl.formatMessage({
        id: 'global.button.cancel',
        defaultMessage: 'Annuler'
    }),
    buttonValid: intl.formatMessage({
        id: 'global.button.confirm',
        defaultMessage: 'Confirmer'
    })
});

class LeaveFeed extends PureComponent {
    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown, false);        
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleSubmit = (e) => {
        this.props.onSubmit(this.props._feed, this.props._me);
        this.props.onClose(e);
    }

    handleKeyDown = (e) => {          
        const {keyCode} = e;
        if (keyCode === 13) {
            this.handleSubmit(e);
        }
    }

    render() {

        const {
            intl,
            onClose,
            name
        } = this.props;
        const i18n = formatMessages(intl)({
            name
        });

        return (
            <Modal
                isOpen
                title={i18n.modalTitle}
                footer={(
                    <>
                        <Button
                            isTransparent
                            onClick={onClose}
                        >
                            {i18n.buttonCancel}
                        </Button>
                        <Button
                            color="danger"
                            onClick={this.handleSubmit}
                        >
                            {i18n.buttonValid}
                        </Button>
                    </>
                )}
                onClose={onClose}
            >
                {i18n.modalContent}
            </Modal>
        );
    }

}

LeaveFeed.propTypes = {
    intl: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    _feed: PropTypes.string.isRequired,
    _me: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default injectIntl(LeaveFeed);
